export const FIRST = 'FIRST'
export const SECOND = 'SECOND'
export const THIRD = 'THIRD'
export const FOURTH = 'FOURTH'
export const FIFTH = 'FIFTH'
export const SIXTH = 'SIXTH'
export const SEVENTH = 'SEVENTH'
export const EIGHTH = 'EIGHTH'
export const OTHER = 'OTHER'
